export const mapControlSurfaceClass =
  "rounded-lg border border-border bg-card/95 text-card-foreground shadow-lg backdrop-blur-sm";

export const mapControlHeaderClass =
  "border-b border-border bg-muted/45";

export const mapControlButtonClass =
  "text-muted-foreground hover:bg-muted hover:text-foreground";

export const mapControlSubtleButtonClass =
  "bg-muted/70 text-muted-foreground hover:bg-muted hover:text-foreground";

export const mapControlInputClass =
  "border border-border bg-background text-foreground placeholder:text-muted-foreground";

export const mapControlDividerClass = "border-border";

export const mapControlText = {
  primary: "hsl(var(--foreground))",
  secondary: "hsl(var(--muted-foreground))",
  tertiary: "hsl(var(--text-tertiary))",
  muted: "hsl(var(--muted-foreground))",
} as const;
